import React from 'react';
import { LayoutDashboard, Users, SquareKanban, Tags, Settings, ShieldCheck, Activity, LogOut, Database } from 'lucide-react';
import { useAuth, ROLES } from '../context/AuthContext';

const Sidebar = ({ currentView, setCurrentView }) => {
  const { user, logout } = useAuth();

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.VIEWER] },
    { id: 'pipeline', label: 'Embudos (Pipeline)', icon: SquareKanban, roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.VIEWER] },
    { id: 'contacts', label: 'Contactos', icon: Users, roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.VIEWER] },
    { id: 'activities', label: 'Actividades', icon: Activity, roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.VIEWER] },
    { id: 'campaigns', label: 'Campañas', icon: Tags, roles: [ROLES.ADMIN, ROLES.EDITOR] }, // Viewer no puede
    { id: 'datahub', label: 'Data Hub (CSV)', icon: Database, roles: [ROLES.ADMIN, ROLES.EDITOR] }, // Ingesta Masiva
    { id: 'settings', label: 'Configuración', icon: Settings, roles: [ROLES.ADMIN] }, // Solo Admin
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-logo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ backgroundColor: 'white', padding: '0.6rem 0.5rem', borderRadius: '6px', width: '100%', display: 'flex', justifyContent: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <img src="/logo.png" alt="Veritas" style={{ height: '32px', objectFit: 'contain' }} />
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.filter(item => item.roles.includes(user?.role)).map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.id}
              className={`nav-item ${currentView === item.id ? 'active' : ''}`}
              onClick={() => setCurrentView(item.id)}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </div>
          );
        })}
      </nav>

      {/* Salir de la Plataforma */}
      <div style={{ marginTop: 'auto', padding: '1rem', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <button 
          onClick={logout} 
          style={{ 
            width: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem', 
            padding: '0.75rem 1rem', 
            backgroundColor: 'transparent', 
            color: '#f87171', 
            border: 'none', 
            borderRadius: '6px', 
            cursor: 'pointer',
            textAlign: 'left',
            transition: 'background-color 0.2s',
            fontWeight: 500
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(248, 113, 113, 0.1)'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        >
          <LogOut size={18} />
          <span>Cerrar Sesión</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
